import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AiStatusPanel from "@/components/AiStatusPanel";
import { useAuth } from "@/lib/auth";
import { Shield, ArrowLeft } from "lucide-react";

/**
 * /admin/ai-status — admin-only dashboard for Universal-Key health.
 * Lightweight page wrapper around the AiStatusPanel component so the panel
 * itself stays embeddable (e.g. in a tabbed admin shell later).
 */
export default function AiStatus() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/sign-in?redirect=/admin/ai-status");
    }
  }, [loading, user, navigate]);

  if (loading) return null;

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 flex flex-col">
      <Header />
      <main className="flex-1 max-w-7xl mx-auto w-full px-6 lg:px-10 py-12">
        {/* Breadcrumb / back link */}
        <div className="flex items-center gap-3 text-xs text-slate-500 dark:text-slate-400 mb-6">
          <Link
            to="/account"
            data-testid="ai-status-back-link"
            className="inline-flex items-center gap-1 hover:text-slate-900 dark:hover:text-slate-100 transition-colors"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> Account
          </Link>
          <span aria-hidden>·</span>
          <span className="inline-flex items-center gap-1 text-slate-700 dark:text-slate-200">
            <Shield className="h-3.5 w-3.5" /> Admin
          </span>
          <span aria-hidden>·</span>
          <span>AI Status</span>
        </div>

        <AiStatusPanel />
      </main>
      <Footer />
    </div>
  );
}
